import axios from "axios";

//--------------  Общие функции для проекта  ----------------------------

//проверка объекта на пустоту
function isEmpty(obj) {
	// если тело цикла начнет выполняться - значит в объекте есть свойства
	for (let key in obj) {
		return false;
	}
	return true;
}

//проверка двух массивов номеров заявок на идентичность, используется для уведомлений
function isArraysAreEqual(array1, array2) {
	if (!Array.isArray(array1)) throw new Error(`Ошибка isArraysAreEqual(): ${array1} не является массивом`);
	if (!Array.isArray(array2)) throw new Error(`Ошибка isArraysAreEqual(): ${array2} не является массивом`);

	const string1 = array1.map(x => +x.npp).sort((a, b) => a - b).join();
	const string2 = array2.map(x => +x.npp).sort((a, b) => a - b).join();
	// console.log('string1', string1);
	// console.log('string2', string2);
	return string1 === string2;
}

//проверяем есть ли в массиве arr1 значения которых нет в arr2 (функция не симметрична)
function arrayDifference(arr1, arr2) {
	return arr1.filter(x => !arr2.includes(x));
}

//получаем объект аптеки и сохраняем его в localStorage
async function getAndSaveAptekaToLocalStorage(idapt, email) {
	try {
		const response = await axios.get("data/getClient", {params: {apteka_id: idapt, email}});
		const apteka = response.data[0];
		// console.log(apteka);
		localStorage.setItem('apteka', JSON.stringify(apteka));
		return Promise.resolve();
	} catch (error) {
		throw new Error(error);
	}
}

//вырезаем из адресной строки параметр guid
function cutGuidFromUrl(url) {
	let fullPath = url.split('?');
	const firstPart = Array.isArray(fullPath) ? fullPath[0] : '';
	let secondPart = Array.isArray(fullPath) ? fullPath[1] : '';
	if (secondPart && firstPart) {
		secondPart = secondPart
			.split('&')
			.filter(x => x.toLowerCase().indexOf('guid') === -1)
			.join('&');
		fullPath = secondPart ? `${firstPart}?${secondPart}` : firstPart;
	} else {
		fullPath = url;
	}
	return fullPath;
}

//ограничение количества вызовов функции, используется при событии resize (изменение размеров элемента на странице)
function debounce(func, wait, immediate) {
	let timeout;
	return function () {
		let context = this, args = arguments,
			later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			},
			call_now = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (call_now) func.apply(context, args);
	}
}

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export {
	isEmpty,
	isArraysAreEqual,
	arrayDifference,
	getAndSaveAptekaToLocalStorage,
	cutGuidFromUrl,
	debounce,
	sleep
}


// WEBPACK FOOTER //
// ./Components/utilities/utilities.js